module.exports = __webpack_public_path__ + "static/media/WebPoker.d913a4d6.webm";